module.exports = __webpack_public_path__ + "static/vib_play0-5ab80ab1ec8aeda85996c9d430d47847.jpg";